
















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
@Component
export default class SearchBar extends Vue {
  @Prop({
    type: Boolean,
    default: () => false
  })
  showDemo!: boolean

  @Prop({
    type: Object,
    default: () => {
      return {
        placeholder: '',
        isShowScan: false
      }
    }
  })
  SearchBarConfig!: any
}
